import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Add from './Add';
import Login from './Login';
import { useGetAccounts } from '../../../hooks/useAccount';
import Loader from '../../Loader';

export default function Cashiers() {
  const staff = useGetAccounts('staff');
  const admins = useGetAccounts('admin');

  if (staff.isLoading || admins.isLoading) return <Loader />;

  return (
    <Routes>
      <Route path="/add" element={<Add />} />
      <Route path="/" element={<Login />} />
    </Routes>
  )
}
